import Vue from "vue";
import Router from "vue-router";

// router懒加载
// const selection = resolve => require(["@/page/selection"], resolve);
// const selectionMobile = resolve => require(["@/page/selectionMobile"], resolve);
const summit = resolve => require(["@/page/summit"], resolve);
const summitMobile = resolve => require(["@/page/summitMobile"], resolve);
const person = resolve => require(["@/page/person"], resolve);
const personMobile = resolve => require(["@/page/personMobile"], resolve);
const activity = resolve => require(["@/page/activity"], resolve);
const activityMobile = resolve => require(["@/page/activityMobile"], resolve);
const market = resolve => require(["@/page/market"], resolve);
const marketMobile = resolve => require(["@/page/marketMobile"], resolve);
const layout = resolve => require(["@/layout/default"], resolve);

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "selection",
      redirect: { name: "selection" },
      component: layout,
      children: [
        {
          path: "/selectionPc",
          name: "selectionPc",
          // component: selection
          component: summit
        },
        {
          path: "/selection",
          name: "selection",
          // component: selectionMobile
          component: summitMobile,
          meta: {
            keepAlive: true // 需要被缓存
          }
        },
        {
          path: "/summitPc",
          name: "summitPc",
          // component: summit
          component: summit,
        },
        {
          path: "/summit",
          name: "summit",
          component: summitMobile,
          meta: {
            keepAlive: true // 需要被缓存
          }
        },
        {
          path: "/personPc",
          name: "personPc",
          component: person
        },
        {
          path: "/person",
          name: "person",
          component: personMobile,
        },
        {
          path: "/activityPc",
          name: "activityPc",
          component: activity
        },
        {
          path: "/activity",
          name: "activity",
          component: activityMobile
        },
        {
          path: "/marketPc",
          name: "marketPc",
          component: market
        },
        {
          path: "/market",
          name: "market",
          component: marketMobile
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => { 
  console.log(to,'router.beforeEach')
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js